import { useBrandCart } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useBrandCart";
import { useMemo } from "react";
export var useCartBrand = function(brandToken) {
    var _useBrandCart = useBrandCart(brandToken), brandCart = _useBrandCart.data;
    var cartBrand = useMemo(function() {
        var _brandCart_brand_carts;
        return brandCart === null || brandCart === void 0 ? void 0 : (_brandCart_brand_carts = brandCart.brand_carts) === null || _brandCart_brand_carts === void 0 ? void 0 : _brandCart_brand_carts.find(function(cart) {
            return cart.brand_token === brandToken;
        });
    }, [
        brandCart,
        brandToken
    ]);
    return cartBrand;
};
